// SPDX-License-Identifier: AGPL-3.0-or-later
// Popular Fusion local overlay — safe to delete after the season.

import {holidaySeasonPhase} from '@app/features/holiday/utils/holidaySeason';

export const HALLOWEEN_DM_ICON_SEASON_CLASS = 'halloween-dm-icon-season';

/**
 * Follows the Halloween pack's calendar window (Sep 1 through Oct 31, local time) rather than
 * repeating those dates. Calendar only — this overlay ignores holiday preferences by design.
 */
export function isHalloweenDmIconSeasonActive(date: Date = new Date()): boolean {
	return holidaySeasonPhase('halloween', date) !== 'off';
}
